import { memo, useMemo } from 'react';

import { useAppSelector } from '@/app/store/hooks';
import { selectJettonBets, selectJettonIndex, selectJettonStatus } from '@/entities/jetton';
import { formatCurrencyValue } from '@/shared/lib/currency';
import { PlayerList, type PlayerListItem } from '@/shared/ui/PlayerList';

export const LivePlayers = memo(() => {
  const bets = useAppSelector(selectJettonBets);
  const status = useAppSelector(selectJettonStatus);
  const roundIndex = useAppSelector(selectJettonIndex);

  const items: PlayerListItem[] = useMemo(
    () =>
      bets.map((bet) => {
        const cashed = bet.cashoutMultiplier != null;
        const lost = status === 'crashed' && !cashed;
        return {
          id: bet.userId,
          username: bet.username,
          avatar: bet.avatar,
          amount: formatCurrencyValue(bet.amount, (bet.currency as 'TON' | 'STARS') ?? 'TON'),
          extra: cashed ? (
            <span className="player-list__cashout">{bet.cashoutMultiplier!.toFixed(2)}x</span>
          ) : undefined,
          status: cashed ? 'won' : lost ? 'lost' : 'default',
        };
      }),
    [bets, status],
  );

  return <PlayerList title={`Round #${roundIndex} Players:`} count={bets.length} items={items} />;
});
